var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import { TableRow } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
var useStyles = makeStyles(function (theme) { return ({
    root: {
        backgroundColor: function (_a) {
            var isDragging = _a.isDragging, isSelectedForPlayer = _a.isSelectedForPlayer;
            if (isDragging) {
                return theme.palette.action.selected;
            }
            return isSelectedForPlayer
                ? theme.palette.action.hover
                : theme.palette.background.paper;
        },
    },
}); });
export var TrackRow = function (_a) {
    var children = _a.children, isSelectedForPlayer = _a.isSelectedForPlayer, provided = _a.provided, snapshot = _a.snapshot;
    var classes = useStyles({
        isSelectedForPlayer: isSelectedForPlayer,
        isDragging: (snapshot === null || snapshot === void 0 ? void 0 : snapshot.isDragging) || false,
    });
    return (React.createElement(TableRow, __assign({ classes: { root: classes.root } }, provided === null || provided === void 0 ? void 0 : provided.draggableProps, { innerRef: provided === null || provided === void 0 ? void 0 : provided.innerRef }), children));
};
